export default  {
    name: 'to teach_',
    app:'to learn_'
  }